export default __webpack_public_path__ + "static/media/BMMF-Phone01.48478138.webp";